import styled, { css, keyframes } from 'styled-components';

// Anel que sai do ponto e some, como um sinal "ao vivo".
const ripple = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.55;
  }
  80%,
  100% {
    transform: scale(2.8);
    opacity: 0;
  }
`;

// O próprio ponto respira de leve, no mesmo ritmo do anel.
const breathe = keyframes`
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.85);
  }
`;

interface PulsingDotProps {
  /** Por cima do ícone, para o menu recolhido. */
  $floating?: boolean;
}

/** Ponto vermelho pulsando: algo pede a atenção do cliente. */
export const PulsingDot = styled.span<PulsingDotProps>`
  display: inline-block;
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f5222d;
  box-shadow: 0 0 6px rgba(245, 34, 45, 0.45);
  animation: ${breathe} 2s ease-in-out infinite;

  &::before,
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: #f5222d;
    animation: ${ripple} 2s cubic-bezier(0.22, 0.61, 0.36, 1) infinite;
    pointer-events: none;
  }

  &::after {
    animation-delay: 1s;
  }

  ${({ $floating }) =>
    $floating
      ? css`
          position: absolute;
          top: -2px;
          right: -3px;
        `
      : css`
          /* && vence regras de span do item de menu */
          && {
            position: relative;
            margin-left: auto;
            margin-right: 4px;
            overflow: visible;
          }
        `}

  @media (prefers-reduced-motion: reduce) {
    animation: none;

    &::before,
    &::after {
      animation: none;
      opacity: 0;
    }
  }
`;
